import { useInstantSearch } from 'react-instantsearch'

import type { ReactElement } from 'react'

import './styles.scss'

const AlgoliaNoResultsBoundary = ({
  children,
  fallback,
}: {
  children: JSX.Element
  fallback: JSX.Element
}): ReactElement => {
  const { results } = useInstantSearch()

  // The `__isArtificial` flag makes sure not to display the No Results message
  // when no hits have been returned yet.
  if (!results.__isArtificial && results.nbHits === 0) {
    return (
      <>
        {<div className="algolia-no-results-boundary">{fallback}</div>}
        <div hidden>{children}</div>
      </>
    )
  }

  return children
}

export default AlgoliaNoResultsBoundary
